module.exports = __webpack_public_path__ + "web-icons.71af56138b4bd557e332.eot";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/fonts/web-icons/web-icons.eot
// module id = ../../../../../src/fonts/web-icons/web-icons.eot
// module chunks = styles